/**
 * @author 3173
 * @description 直播列表
 * @Date 2020/9/28
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;

class LiveList extends WizContainer {

  componentName = 'liveList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      // let f = (v) => {
      //   v && v.forEach(val => {
      //    // val['name'] = checkStrLength(val['name'], len);
      //     val['startDate'] = val['startDate'].substring(0,val['startDate'].length-3)
      //   });
      // }
      // f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '直播名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开播时间',
        field: 'startDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '直播类型',
        field: '_liveType',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '观看类型',
        field: '_watchType',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '直播分类',
        field: 'categoryName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '直播受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      },
      {
        headerName: '直播状态',
        field: '_state',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '直播房间',
        field: 'ownerId',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否允许匿名互动',
        field: 'anonymous',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.dataList && data.dataList.forEach(d => {
        d.anonymous = d.anonymous== 1 ? "是":"否"
        let _d = { ...d }
      let authData = d['authInfo']
      let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['scope'] = target
        _data.push(_d)
      });

      WizBrowserExport({
        title: '直播信息',
        sheetName: '直播信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '直播信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _handlePersonInfoFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
     /*  {
        headerName: '证件号码',
        field: 'idCard',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }, */
      {
        headerName: '手机号',
        field: 'mobile',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userTypeStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号状态',
        field: 'stateStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgNameAll',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      },
      {
        headerName: '经销商编码',
        field: 'dealerCode',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '直播受众人员信息',
        sheetName: '直播受众人员信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '直播受众人员信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _handleGetUrlData(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      window.open(o['data'], '_blank')
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        list: this._handleListData,
        setLiveStatus: this._handleCMD,
        setInteractLiveState: this._handleCMD,
        export: this._handleFile,
        delete: this._handleCMD,
        exportLiveAuthInfo: this._handlePersonInfoFile,
        getWebUploadBackPlayUrl: this._handleGetUrlData,
      },

    })
    return <WizReduxTemplate {..._reduxTemplateCofig}  />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LiveList);
